import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';
import { ImmigrationProfessionalPayload } from '../models/payload';
import { IImmigrationProfessional } from '../models/response';

export function post(
    payload: ImmigrationProfessionalPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> {
    return client.post<{ msg: string }>('/immigration_professional', payload, customConfig);
}

export function put(
    id: unknown,
    payload: ImmigrationProfessionalPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> {
    return client.put<{ msg: string }>(`/immigration_professional/${id}`, payload, customConfig);
}

export function get(
    id: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<IImmigrationProfessional>> {
    return client.get<IImmigrationProfessional>(`/immigration_professional/${id}`, customConfig);
}

export function checkLicense(
    license_number: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> {
    return client.get<{ msg: string }>(
        `/check_license/${encodeURIComponent(license_number)}`,
        customConfig
    );
}

export function deleteProfessional(
    user_id: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse> {
    return client.delete(`/immigration_professional/${user_id}`, customConfig);
}
